import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { fuseAnimations } from '../../../../../core/animations';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { SubjectService } from '../../../../services/subject/subject.service';
import { Observable } from 'rxjs/Observable';
import { EventService } from '../../../../services/events/event.service';
import { SubjectSchedule } from '../../../../models/subjects/dto/SubjectSchedule';
import { environment } from '../../../../../../environments/environment';
import { Location } from '@angular/common';
import { DivisionService } from '../../../../services/divisions/division.service';
import { DivisionSubjectDto, SubjectTeacherDto } from '../../../../models/divisions/division-subject';
import { AddEditSubjectTeacherComponent } from '../subject-division-teacher/components/add-subject-teacher/add-edit-subject-teacher.component';
import { EditTeacherComponent } from './edit-teacher/edit-teacher.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'fuse-divisions-schedule',
    templateUrl: './divisions-schedule.component.html',
    styleUrls: ['./divisions-schedule.component.scss'],
    animations: fuseAnimations
})
export class DivisionsScheduleComponent implements OnInit, OnDestroy, AfterViewInit {
    @BlockUI('tracker') blockUIList: NgBlockUI;
    @ViewChild('scheduletable') scheduletable: ElementRef;
    subjects: SubjectSchedule[] = [];
    schedules = [];
    days = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes'];
    subjectDivHeight = 350;
    data: any;
    private sub: any;
    public divisionId: number;
    public division: any;
    confirmDialogRef: any;

    constructor(private authenticationService: AuthenticationService,
                public dialog: MatDialog,
                private router: Router,
                private subjectService: SubjectService,
                private eventService: EventService,
                private route: ActivatedRoute,
                private sweetAlertService: SweetAlertService,
                private divisionService: DivisionService,
                private translateService: TranslateService,
                private location: Location) {
        this.data = {mode: 'edit'};
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    ngOnInit(): void {
        this.sub = this.route.params.subscribe(params => {
            this.divisionId = params['id'] !== undefined ? +params['id'] : -1;
        });


        this.blockUIList.start('Cargando datos...');
        Observable.combineLatest(
            this.subjectService.getAllByDivision(this.divisionId),
            this.eventService.getScheduleByDivision(this.divisionId),
            this.divisionService.getById(this.divisionId)
        ).subscribe(([subjects, events, division]) => {
            console.log('subjects>>>', subjects);
            console.log('division>>>', division);
            console.log('event>>>', events);
            subjects.forEach((e, index) => {
                e.Class = 'color_' + (index + 1);
                e.SubjectPeriodsAssigned = 0;
            });

            events.forEach(e => {
                e.FinishDate = new Date(e.FinishDate + 'Z');
                e.StartDate = new Date(e.StartDate + 'Z');
            });

            this.schedules = events;
            this.subjects = subjects;
            this.division = division;

            this.schedules.forEach(s => {
                console.log('s >>>>>> s', s);
                s.EventRepeats.forEach(r => {
                    //console.log('r >>>>>> r', r);
                    r.Subjects.forEach(subject => {
                        //console.log('subject >>>>>> s', subject);
                        //console.log('this.subjects >>>>>> s', this.subjects);
                        const foundSubject = this.subjects.find(e => e.SubjectId === subject.SubjectId);
                        //console.log('foundSubject', foundSubject);
                        if (foundSubject) {
                            subject.Class = foundSubject.Class;
                            subject.SubjectDescription = foundSubject.SubjectDescription;
                            subject.SubjectPeriods = foundSubject.SubjectPeriods;
                            subject.SubjectPeriodsAssigned = foundSubject.SubjectPeriodsAssigned;
                        }
                    });
                });
            });

            this.countSubjectsAssigned();

            this.blockUIList.stop();
        });
    }

    ngAfterViewInit() {
        this.subjectDivHeight = this.scheduletable.nativeElement.clientHeight;
    }

    // event contiene el elemento que quiero ingresar
    // eventRepeats contiene los elementos ya dropeados (la libreria lo dropea por defecto)
    // lo que se quiere buscar es dejar en el array el elemento seleccionado
    onDropElement(event, eventRepeat) {
        if (eventRepeat.Subjects.length > 1) {
            this.sweetAlertService.question('aviso', '¿Desea reemplazar la materia asignada a ese horario?', 'Aceptar', 'Cancelar',
                () => {
                    const subjectsFiltered = [];
                    eventRepeat.Subjects.forEach(s => {
                        if (s.SubjectId !== event.value.SubjectId) { //  es distinto del que quiero ingresar
                            // pregunto si ya esta en el array (puede que sea repetido)
                            const found = subjectsFiltered.find(e => e.SubjectId === event.value.SubjectId);
                            if (!found) {
                                subjectsFiltered.push(event.value);
                            }
                        }
                    });
                    if (!subjectsFiltered.length) {
                        subjectsFiltered.push(eventRepeat.Subjects[0]);
                    }
                    eventRepeat.Subjects = subjectsFiltered;
                    this.countSubjectsAssigned();
                },
                () => {
                    const subjectsFiltered = [];
                    eventRepeat.Subjects.forEach(s => {
                        if (s.SubjectId !== event.value.SubjectId) { //  es distinto del que quiero ingresar
                            // pregunto si ya esta en el array (puede que sea repetido)
                            const found = subjectsFiltered.find(e => e.SubjectId === s.SubjectId);
                            if (!found) {
                                subjectsFiltered.push(s);
                            }
                        }
                    });
                    if (!subjectsFiltered.length) {
                        subjectsFiltered.push(eventRepeat.Subjects[0]);
                    }
                    eventRepeat.Subjects = subjectsFiltered;
                    this.countSubjectsAssigned();
                });
        }else{
            this.countSubjectsAssigned();
        }
    }

    onDropSubjectsElement(event) {
        const subjectsFiltered = [];
        this.subjects.forEach(s => {
            const found = subjectsFiltered.find(e => e.SubjectId === s.SubjectId);
            if (!found) {
                subjectsFiltered.push(s);
            }
        });
        this.subjects = subjectsFiltered;
        this.countSubjectsAssigned();
    }

    onDragElement($event: any) {
        console.log('drag>>>>>>', $event);
    }

    countSubjectsAssigned() {
        let subjectsAssigned = [];
        this.schedules.filter(s => s.EventTypeId === 1).forEach(e => {
            e.EventRepeats.forEach(f => {
                subjectsAssigned = subjectsAssigned.concat(f.Subjects);
            });
        });

        this.subjects.forEach(s => {
            s.SubjectPeriodsAssigned = subjectsAssigned.filter(e => e.SubjectId === s.SubjectId).length;
        });
    }

    checkAllAssigned() {

    }

    check() {
        // preparar datos a enviar
        const r = this.subjects.filter(e => e.SubjectPeriods !== e.SubjectPeriodsAssigned);
        console.log('result', r);
        if (r.length) {
            this.sweetAlertService.question('aviso', 'No se asignaron todos los horarios', 'Aceptar', 'Cancelar',
                () => {
                    this.save();
                });
        } else {
            this.save();
        }
    }

    save() {
        const datos = [];
        this.schedules.forEach(schedule => {
            schedule.EventRepeats.forEach(eventRepeat => {
                eventRepeat.Subjects.forEach(subject => {
                    const element = new SubjectDivisionSchedule(eventRepeat.EventRepeatId, subject.SubjectId);
                    datos.push(element);
                });
            });
        });
        this.blockUIList.start('Guardando datos...');
        const data = {
            DivisionId: this.divisionId,
            Datos: datos
        };
        this.eventService.add(data).subscribe(response => {
            this.translateService.get('LABELS.DATA_SAVED_CORRECTLY').subscribe(res => {
                this.sweetAlertService.success('', res);
            });
            this.blockUIList.stop();
            // this.router.navigate(['pages/management/schoolyear/edit']);
            this.location.back();
        }, error => {
            this.blockUIList.stop();
            // this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
            //     this.sweetAlertService.error('Error', res, null);
            // });
        });
    }

    public back() {
        this.location.back();
    }

    public printDivisionSchedule() {
        window.open(environment.backendUri + 'report/divisionschedule/' + this.divisionId, '_new');
    }

    public editTeacher(subject) {
        console.log('subject', subject, this.divisionId);
        if (!subject.MainTeacher) {
            subject.MainTeacher = new SubjectTeacherDto();
        }
        if (!subject.SubstituteTeacher) {
            subject.SubstituteTeacher = new SubjectTeacherDto();
        }
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'edit',
                divisionId: this.divisionId,
                subject: JSON.parse(JSON.stringify(subject))
            }
        };

        this.confirmDialogRef = this.dialog.open(EditTeacherComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                subject.MainTeacher = result.MainTeacher;
                subject.SubstituteTeacher = result.SubstituteTeacher;
                this.schedules.forEach(s => {
                    s.EventRepeats.forEach(e => {
                        e.Subjects.forEach(sub => {
                            if (sub.SubjectId === subject.SubjectId) {
                                sub.MainTeacher = result.MainTeacher;
                                sub.SubstituteTeacher = result.SubstituteTeacher;
                            }
                        });
                    });
                });
            }
        });
    }
}

export class SubjectDivisionSchedule {
    EventRepeatId: number;
    SubjectId: number;

    constructor(EventRepeatId, SubjectId) {
        this.EventRepeatId = EventRepeatId;
        this.SubjectId = SubjectId;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/divisions-schedule/divisions-schedule.component.ts